// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Iob","question":"e_Job","button":"e_Kob","buttonNegative":"e_Lob","buttonPositive":"e_Mob","icon":"e_Nob","iconNegative":"e_Oob","iconPositive":"e_Pob"};